import { ApiResponse } from '@restaurant/types';
import httpClient from '~/http';
import { PaymentAccount } from '~/types/payment';
import { PaymentAccountFormValues } from '../types';

export type PaymentAccountResponse = {
  paymentAccounts: PaymentAccount[];
};

export const fetchPaymentAccounts = () => {
  return httpClient.get<PaymentAccountResponse>('/api/v2/payment-accounts');
};

export const createPaymentAccount = (item: PaymentAccountFormValues) => {
  return httpClient.post<ApiResponse<null>>(`/api/v2/payment-accounts`, item);
};

export const updatePaymentAccount = (
  id: string,
  item: PaymentAccountFormValues
) => {
  return httpClient.put<ApiResponse<null>>(
    `/api/v2/payment-accounts/${id}`,
    item
  );
};
